import { ByteString } from "../ByteString.js";
export class ByteStringRange {
    start;
    end;
    static is(val) {
        return !!(val &&
            typeof val === "object" &&
            "start" in val &&
            ByteString.is(val.start) &&
            (!("end" in val) || val.end === undefined || ByteString.is(val.end)));
    }
    static isValid(val) {
        return val.end === undefined || ByteString.compare(val.start, val.end) <= 0;
    }
    static includes(a, b) {
        if (this.is(b)) {
            return (ByteString.compare(b.start, a.start) >= 0 &&
                (a.end === undefined ||
                    (b.end !== undefined && ByteString.compare(b.end, a.end) <= 0)));
        }
        else {
            return (ByteString.compare(b, a.start) >= 0 &&
                (a.end === undefined || ByteString.compare(b, a.end) < 0));
        }
    }
    static single(val) {
        return {
            start: val,
            end: ByteString.successor(val, length),
        };
    }
    static isSingle(val) {
        return val.end === undefined
            ? false
            : ByteString.isSuccessor(val.end, val.start, undefined);
    }
    static overlapsWith(a, b) {
        if (a.end === undefined) {
            return b.end === undefined || ByteString.compare(b.end, a.start) > 0;
        }
        if (b.end === undefined) {
            return ByteString.compare(a.end, b.start) > 0;
        }
        return ByteString.compare(a.start, b.end) < 0 && ByteString.compare(b.start, a.end) < 0;
    }
    static intersection(a, b) {
        if (!ByteStringRange.overlapsWith(a, b))
            return undefined;
        return {
            start: ByteString.compare(a.start, b.start) > 0 ? a.start : b.start,
            end: a.end === undefined
                ? b.end
                : b.end === undefined
                    ? a.end
                    : ByteString.compare(a.end, b.end) < 0
                        ? a.end
                        : b.end,
        };
    }
    constructor(start, end) {
        this.start = start;
        this.end = end;
    }
}
export function FixedLengthByteStringRange(length, type) {
    return class extends ByteStringRange {
        start;
        end;
        static is(val) {
            return !!(ByteStringRange.is(val) &&
                type.is(val.start) &&
                (val.end === undefined || type.is(val.end)));
        }
        static full() {
            return {
                start: type.least(),
                end: undefined,
            };
        }
        static single(val) {
            return {
                start: val,
                end: type.successor(val),
            };
        }
        static lowerThanOrEqualTo(val) {
            return {
                start: type.least(),
                end: type.successor(val),
            };
        }
        static greaterThanOrEqualTo(val) {
            return {
                start: val,
                end: undefined,
            };
        }
        static isSingle(val) {
            return val.end === undefined
                ? type.isGreatest(val.start)
                : type.isSuccessor(val.end, val.start);
        }
        static intersection(a, b) {
            return super.intersection(a, b);
        }
        constructor(start, end) {
            super(start, end);
            this.start = start;
            this.end = end;
        }
    };
}
//# sourceMappingURL=ByteStringRange.js.map